export { default } from "./SkeletonServices-component";
